"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Helpers
const url_1 = require("@dsk-lib/core/dist/helpers/url");
const profile_service_1 = require("./profile.service");
/**
 * Get school value
 * @param lycee
 * @param college
 */
const getSchool = (lycee, college) => {
    if (typeof lycee === 'string') {
        return lycee;
    }
    if (lycee) {
        return lycee.value;
    }
    if (typeof college === 'string') {
        return college;
    }
    if (college) {
        return college.value;
    }
    return undefined;
};
/**
 * Init profile
 */
exports.initProfileLib = (schoolApiEndPoint) => {
    window.getCollege = (value) => profile_service_1.getSchoolList(schoolApiEndPoint, 'COLLEGE', value);
    window.getLycee = (value) => profile_service_1.getSchoolList(schoolApiEndPoint, 'LYCEE', value);
};
/**
 * Handle submit success redirection
 */
exports.handleSubmitSuccessRedirect = () => {
    const redirectUri = url_1.getUrlParameter('redirect_uri');
    setTimeout(() => {
        // dirty for now waiting update @dsk-lib userHook
        if (redirectUri) {
            const segment = redirectUri === '/' ? '' : `${redirectUri}`;
            window.location.href = `${window.location.origin}${segment}`;
        }
        else {
            window.location.href = window.location.origin;
        }
    }, 2000);
};
/**
 * Get current school year
 */
const getSituationYear = () => {
    const now = new Date();
    const month = now.getMonth();
    if (month >= 8) {
        return now.getFullYear();
    }
    return now.getFullYear() - 1;
};
/**
 * Format form data for api
 * @param formData
 */
exports.formatFormDataForApi = (formData, userProfileVersion) => {
    const { birthday, diploma, domain, externalCandidate, level, sector, status, college, lycee, postalCode, newsletters, speciality } = formData, others = __rest(formData, ["birthday", "diploma", "domain", "externalCandidate", "level", "sector", "status", "college", "lycee", "postalCode", "newsletters", "speciality"]);
    return Object.assign({ address: {
            postalCode
        }, birthday: birthday.substr(0, 10), newsletters: Object.assign({ digiSchool: false, partners: false }, newsletters.reduce((prev, curr) => (Object.assign(Object.assign({}, prev), { [curr]: true })), {})), situation: {
            diploma,
            domain,
            externalCandidate,
            level,
            school: getSchool(lycee, college),
            sectors: sector,
            specialities: speciality,
            status,
            version: userProfileVersion,
            year: getSituationYear()
        } }, others);
};
/**
 * Save user profile
 * @param fetchWithCredentials
 * @param userData
 * @param onSuccess
 * @param onFail
 */
exports.saveUserProfile = (fetchWithCredentials, userData, userProfilVersion, userApiEndPoint, onSuccess, onFail) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetchWithCredentials(`${userApiEndPoint}/users/me`, {
            body: JSON.stringify(exports.formatFormDataForApi(userData, userProfilVersion)),
            headers: { 'content-type': 'application/json', accept: 'application/json' },
            method: 'PATCH'
        });
        if (!response.ok) {
            onFail(`Une erreur est survenu lors de l'enregistrement de votre profil: Error ${response.status} - ${response.statusText}`);
            return false;
        }
        else {
            onSuccess('Votre profil a bien été enregistré');
            return true;
        }
    }
    catch (error) {
        onFail(`Une erreur est survenu lors de l'enregistrement de votre profil: Error ${error}`);
        console.log(error);
        return false;
    }
});
//# sourceMappingURL=profile.core.js.map